/* src/app/components/account/archive-job/download-archive-dialog/download-archive-dialog.component.scss */
mat-form-field.custom-infix-padding {
  --padding-top: 20px;
  --padding-bottom: 16px;
}
.mat-mdc-dialog-content {
  padding: 12px 24px 12px 24px;
  min-width: 200px;
  min-height: 50px;
  display: flex;
  flex-direction: column;
}
.mat-mdc-dialog-title {
  padding: 24px 24px 24px 20px;
  margin: -24px -24px 10px -24px;
  background-color: rgb(48, 63, 159);
  color: white;
}
.form-control-wrapper mat-form-field {
  width: 100%;
}
/*# sourceMappingURL=download-archive-dialog.component.css.map */
